//获取时间
function getDay(day) { //这里的day是时间（列如：7，-7）
	let today = new Date();
	let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
	today.setTime(targetday_milliseconds); //注意，这行是关键代码，到这时间已经转行为毫秒
	return format(today)
}
//格式化日期
function format(date) {
	let year = date.getFullYear()
	let month = date.getMonth() + 1
	let day = date.getDate()
	if (month >= 1 && month <= 9) {
		month = `0${month}`
	}
	if (day >= 1 && day <= 9) {
		day = `0${day}`
	}
	return `${year}-${month}-${day}`
}
export default getDay


// WEBPACK FOOTER //
// ./static/js/function/FormatTime.js